/*
 * @Description   : aegis 上报 before-request 钩子
 * @usage         :
 * @Date          : 2022-04-22 19:26:08
 * @Author        : hadeshe93<hadeshe93@gmail.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-20 17:35:07
 * @FilePath: /app-monorepo-projects/packages/app-share/src/libs/ageis/before-request.ts
 */
import { EAegisLogTypes, EAegisLogLevelTypes } from '@/constants/aegis';
import { BeforeRequestManager } from './hook-manager';

// AJAX 日志黑名单
const AJAX_URL_BLACKLIST = ['h.trace.qq.com', 'beacon.qq.com', 'tencent-cloud.com'];
// 白名单日志黑名单
const LOG_URL_BLACKLIST = [
  ...AJAX_URL_BLACKLIST,
  // 忽略 接口上报，原因如下：
  // 1. api 全量上报中，忽略 接口的上报，因为其相应数据被 aegis 默认限制序列化层级后，日志信息还是很大
  // 2. aegis 目前暴露的配置无法做到单独对指定接口做回包日志裁剪及定制
  // 3. 可以在服务端日志中查
  'https://api.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy/GetUser',
  'https://api.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy/WSGetCollectionFeedList',
  'https://api.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy/WSH5GetPlayPage',
];
const beforeRequestManager = new BeforeRequestManager();

// 注册「日志」类型+「错误」等级回调：忽略 aegis 自身错误
beforeRequestManager.register(EAegisLogTypes.LOG, (data) => {
  const isAegisJsError = data.logType === EAegisLogTypes.LOG
    && data.logs?.level === EAegisLogLevelTypes.jsExcutionError
    && (data.logs?.msg || '').indexOf('Script error. @ (:0:0)') > -1;

  // 取反，返回 false，让其不上报
  return !isAegisJsError;
});

// 注册「日志」类型+「白名单」等级回调：忽略业务上报接口
beforeRequestManager.register(EAegisLogTypes.LOG, (data) => {
  const isWhiteListLog = data.logType === EAegisLogTypes.LOG
    && data.logs?.level === EAegisLogLevelTypes.whiteListLog;
  if (!isWhiteListLog) return true;

  const sourceText = getReqUrlPartFromLogMsg(data.logs?.msg);
  const isBlackListUrlContained = LOG_URL_BLACKLIST.some(url => (sourceText).indexOf(url) >= 0);
  return !isBlackListUrlContained;
});

// 注册「日志」类型+「Ajax 请求异常」等级回调：忽略业务上报接口
beforeRequestManager.register(EAegisLogTypes.LOG, (data) => {
  const isAjaxErrorLog = data.logType === EAegisLogTypes.LOG
    && data.logs?.level === EAegisLogLevelTypes.ajaxError;
  if (!isAjaxErrorLog) return true;

  const sourceText = getReqUrlPartFromLogMsg(data.logs?.msg);
  const isBlackListUrlContained = AJAX_URL_BLACKLIST.some(url => (sourceText || '').indexOf(url) >= 0);
  return !isBlackListUrlContained;
});

// 注册「测速」类型回调：忽略业务上报接口
// - 取反，返回 false，让其不上报
beforeRequestManager.register(EAegisLogTypes.SPEED, (data) => {
  const isBlackListUrlContained = AJAX_URL_BLACKLIST.some(url => (data.logs?.url || '').indexOf(url) >= 0);
  return !isBlackListUrlContained;
});

// 返回匹配日志上报信息中的请求链接部分
function getReqUrlPartFromLogMsg(msg: string) {
  return (msg || '').match(/req url:[^\n]*\n/)?.[0] || '';
}

export {
  beforeRequestManager,
};
